export default __webpack_public_path__ + "static/media/wwf_medium.876151ba.jpg";